import { Link } from 'react-router-dom'
import { ROUTES } from '@constants'

function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="text-center animate-fade-in">
        <h1 className="text-9xl font-bold text-gradient-ligdi mb-4">404</h1>
        <h2 className="text-3xl font-bold text-gray-800 mb-4">Page non trouvée</h2>
        <p className="text-xl text-gray-600 mb-8">Désolé, la page que vous recherchez n'existe pas.</p>
        <Link to={ROUTES.HOME} className="btn-primary inline-block">
          Retour à l'accueil
        </Link>
      </div>
    </div>
  )
}

export default NotFoundPage
